import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

import {
  IconButton,
  Snackbar,
  Grid
}  from 'e100-react-components';
import {
  useIsAddingFavouriteBrandsDone,
  useBrandsOperations
} from 'entities/brands';
import { FavouriteStationIcon } from 'entities/stations';

import { useBoolState } from 'common/hooks';
import { useStyles } from './styles';
import { useIntl } from 'react-intl';

export const FavouriteBrandsAddSnackbar = () => {
  const { formatMessage } = useIntl();
  const [ show,,, onHide, onShow ] = useBoolState(false);
  const classes = useStyles();
  const isAddingFavouriteBrandsDone = useIsAddingFavouriteBrandsDone();
  const { updateAddingFavouriteBrandsStatus } = useBrandsOperations();

  useEffect(() => {
    if (isAddingFavouriteBrandsDone) {
      onShow();
    }
  }, [
    isAddingFavouriteBrandsDone,
    onShow
  ]);

  useEffect(() => () => {
    updateAddingFavouriteBrandsStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!show) {
    return null;
  }

  return createPortal(
    <Snackbar
      open={show}
      onClose={() => {
        updateAddingFavouriteBrandsStatus();
        onHide();
      }}
      message={
        <Grid
          container
          alignItems="center"
          justify="space-between"
          wrap="nowrap"
        >
          <Grid item>
            <FavouriteStationIcon
              color="primary"
            />
          </Grid>
          <Grid item>
            {formatMessage({ id: 'favouriteBrands.added.message' })}
          </Grid>
          <Grid item>
            <IconButton
              kind={'close'}
              onClick={onHide}
              color={'inherit'}
            />
          </Grid>
        </Grid>
      }
      classes={{
        root: classes.root
      }}
      autoHideDuration={2000}
    />,
    document.body
  );
};
